import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export function AnnouncementDialog({ open, onOpenChange, initial, onSaved }) {
  const [f, setF] = useState({ title: "", body: "", priority: "normal", recipient_ids: null, ...(initial || {}) });
  const [people, setPeople] = useState([]);
  useEffect(() => { api.get("/users/directory").then((r) => setPeople(r.data)); }, []);
  const targeted = Array.isArray(f.recipient_ids);
  const toggle = (id) => {
    const cur = f.recipient_ids || [];
    setF({ ...f, recipient_ids: cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id] });
  };
  const submit = async (e) => {
    e.preventDefault();
    if (targeted && f.recipient_ids.length === 0) return toast.error("Seleziona almeno un destinatario");
    const payload = { title: f.title, body: f.body, priority: f.priority, recipient_ids: f.recipient_ids };
    try {
      const { data } = initial?.id ? await api.put(`/announcements/${initial.id}`, payload) : await api.post("/announcements", payload);
      toast.success("Comunicazione salvata");
      onOpenChange(false);
      onSaved(data);
    } catch (e2) {
      toast.error(errMsg(e2));
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl" data-testid="announcement-dialog">
        <DialogHeader><DialogTitle>{initial?.id ? "Modifica comunicazione" : "Nuova comunicazione"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>Titolo</Label><Input value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} required data-testid="announcement-title-input" /></div>
          <div className="space-y-1.5"><Label>Testo</Label><Textarea value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} rows={6} required data-testid="announcement-body-input" /></div>
          <div className="flex items-center justify-between rounded-md border px-3 py-2.5">
            <Label htmlFor="prio">Priorità alta</Label>
            <Switch id="prio" checked={f.priority === "high"} onCheckedChange={(c) => setF({ ...f, priority: c ? "high" : "normal" })} data-testid="announcement-priority-switch" />
          </div>
          <div className="flex items-center justify-between rounded-md border px-3 py-2.5">
            <Label htmlFor="tg">Solo a destinatari selezionati</Label>
            <Switch id="tg" checked={targeted} onCheckedChange={(c) => setF({ ...f, recipient_ids: c ? [] : null })} data-testid="announcement-targeted-switch" />
          </div>
          {targeted && (
            <div className="max-h-44 space-y-1 overflow-y-auto rounded-md border p-2" data-testid="announcement-recipients">
              {people.map((p) => (
                <label key={p.id} className="flex cursor-pointer items-center gap-2.5 rounded px-2 py-1.5 text-sm hover:bg-muted">
                  <Checkbox checked={f.recipient_ids.includes(p.id)} onCheckedChange={() => toggle(p.id)} data-testid={`recipient-${p.id}`} />
                  {p.name}<span className="text-xs text-muted-foreground">{p.department}</span>
                </label>
              ))}
            </div>
          )}
          <DialogFooter><Button type="submit" data-testid="announcement-submit-button">Pubblica</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
